import { useContext } from 'react';
import PermissionsContext, { FeaturesCtxType } from './features-context';

export default function useFeatures(): FeaturesCtxType {
  return useContext(PermissionsContext);
}
